import { useReadContracts } from "wagmi"

import { ETHEREUM_CHAIN_ID } from "#/shared/constants"
import { TbtcBridge, TbtcVault } from "#/shared/constants/artifacts"

const SATOSHI_MULTIPLIER = 10n ** 10n

function fromSatoshi(amount: bigint) {
  return amount * SATOSHI_MULTIPLIER
}

export default function useEstimateTbtcFees(
  amount: bigint = 0n,
  isQueryEnabled: boolean = true,
) {
  const { data, ...rest } = useReadContracts({
    contracts: [
      {
        abi: TbtcBridge.abi,
        address: TbtcBridge.address,
        functionName: "depositParameters",
        chainId: ETHEREUM_CHAIN_ID,
      },
      {
        abi: TbtcVault.abi,
        address: TbtcVault.address,
        functionName: "optimisticMintingFeeDivisor",
        chainId: ETHEREUM_CHAIN_ID,
      },
    ],
    query: {
      // Fetch data only once because it does not change very often.
      staleTime: Infinity,
      gcTime: Infinity,
      enabled: isQueryEnabled,
    },
  })

  const amountInTokenPrecision = fromSatoshi(amount)

  const [, depositTreasuryFeeDivisor, depositTxMaxFeeInSatoshi] = data?.[0]
    .result ?? [0n, 0n, 0n, 0]

  const optimisticMintingFeeDivisor = BigInt(data?.[1].result ?? 0)

  const depositTxMaxFee = fromSatoshi(depositTxMaxFeeInSatoshi)

  const treasuryFee =
    depositTreasuryFeeDivisor > 0
      ? amountInTokenPrecision / depositTreasuryFeeDivisor
      : 0n

  const amountSubTreasury = amountInTokenPrecision - treasuryFee

  const optimisticMintingFee =
    optimisticMintingFeeDivisor > 0
      ? amountSubTreasury / optimisticMintingFeeDivisor
      : 0n

  const totalFee = treasuryFee + optimisticMintingFee + depositTxMaxFee

  return {
    fees: totalFee,
    ...rest,
  }
}
